import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { RecruitingEffects } from 'src/app/recruiting/store/recruiting.effects';
import { RecruitingReducers } from 'src/app/recruiting/store/recruiting.reducers';
import { RecruitingFeatureKey } from 'src/app/recruiting/store/recruiting.selectors';
import { EnvironmentProviders } from '@angular/core';

export const provideRecruitingJobsStore = (): EnvironmentProviders[] => [
    provideState(RecruitingFeatureKey, RecruitingReducers),
    provideEffects(RecruitingEffects)
];
